import React from 'react';
import { arrayOf, shape } from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { TrackMultiOutOfStock } from '@thd-olt-component-react/email-signup';
import { Typography } from '@one-thd/sui-atomic-components';
import { getOOSProductIds, bundleHasOOSProduct } from '../utils/product-unavailable-utils';
/**
 * Component to OOS Messaging component.
 *
 * @param {string} props.itemId - The Bundle Id.
 */

export const BundleTrackOOS = ({ product, products }) => {

  const { hidePrice } = product?.features || {};
  const hasOOsProduct = hidePrice && bundleHasOOSProduct({ products });
  const itemIds = getOOSProductIds({ products });

  if (!hasOOsProduct) {
    return null;
  }

  return (
    <div
    // eslint-disable-next-line max-len
      className="sui-flex sui-flex-col sui-border-primary sui-rounded-md sui-border-1 sui-pt-4 sui-px-4 sui-border-solid"
      data-testid="bundle-track-oos"
    >
      <Typography variant="h4">Items in This Bundle are Out of Stock</Typography>
      <TrackMultiOutOfStock itemIds={itemIds} />
    </div>
  );

};

BundleTrackOOS.propTypes = {
  products: arrayOf(shape({})).isRequired,
  product: shape({}).isRequired
};

BundleTrackOOS.displayName = 'BundleTrackOOS';

BundleTrackOOS.dataModel = extend(TrackMultiOutOfStock);